export const DERIVED_CERTIFICATION_TARGETS = {
  requiredCl: 0.68,
  requiredLd: 10.2,
  requiredPitchMargin: 0,
  requiredCertificationMargin: 0,
};

type Coefficients = {
  cl: number;
  cd: number;
  cm: number;
};

type DomainStatus = {
  min: number;
  max: number;
  value: number;
};

export interface DerivedMetrics {
  ld: number;
  liftReserve: number;
  pitchMargin: number;
  certificationMargin: number;
}

export function calculateDerivedMetrics(coefficients: Coefficients): DerivedMetrics {
  const ld = coefficients.cl / coefficients.cd;
  const liftReserve = coefficients.cl - DERIVED_CERTIFICATION_TARGETS.requiredCl;
  const pitchMargin = -coefficients.cm - 0.035;
  const certificationMargin =
    ((ld - DERIVED_CERTIFICATION_TARGETS.requiredLd) / DERIVED_CERTIFICATION_TARGETS.requiredLd) * 100 +
    liftReserve * 42 +
    pitchMargin * 260;

  return {
    ld,
    liftReserve,
    pitchMargin,
    certificationMargin,
  };
}

export function certificationDecision(mode: "interpolated" | "extrapolated", certificationMargin: number) {
  if (mode === "extrapolated") return "needs additional simulation";
  return certificationMargin >= DERIVED_CERTIFICATION_TARGETS.requiredCertificationMargin
    ? "passes derived margin"
    : "needs design margin";
}

export function calculateProvenanceMargin(nearestSupportDistance: number, trustRadius: number, statuses: DomainStatus[]) {
  const supportSlack = (trustRadius - nearestSupportDistance) / trustRadius;
  const dimensionSlacks = statuses.flatMap((status) => {
    const range = status.max - status.min || 1;
    return [(status.value - status.min) / range, (status.max - status.value) / range];
  });
  return Math.min(supportSlack, ...dimensionSlacks);
}
